import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-sm md:text-base" }
const _hoisted_2 = { class: "mb-6 md:mb-18" }
const _hoisted_3 = { class: "row gutter-y-0" }
const _hoisted_4 = { class: "w-full md:w-1/2" }
const _hoisted_5 = { class: "mt-5 flex items-center justify-between" }
const _hoisted_6 = { class: "checkbox" }
const _hoisted_7 = { class: "relative" }
const _hoisted_8 = ["aria-pressed"]
const _hoisted_9 = {
  key: 0,
  class: "md:hidden"
}
const _hoisted_10 = { class: "order-first ml-auto w-full md:order-last md:w-2/5" }
const _hoisted_11 = {
  class: "mb-12 hidden md:block",
  ref: "summary"
}
const _hoisted_12 = { class: "mb-8" }
const _hoisted_13 = {
  key: 0,
  class: "filter-wrapper relative hidden md:order-last md:block"
}
const _hoisted_14 = {
  key: 0,
  class: "object-list"
}
const _hoisted_15 = {
  key: 1,
  class: "py-4 text-center text-xl font-normal"
}
const _hoisted_16 = {
  key: 2,
  class: "space-y-4"
}
const _hoisted_17 = { class: "flex" }
const _hoisted_18 = {
  key: 0,
  class: "fixed inset-0 z-20 flex flex-col overflow-y-auto bg-white px-5 pb-5 md:hidden"
}
const _hoisted_19 = { class: "flex flex-col space-y-5 pb-18" }
const _hoisted_20 = { class: "sticky top-0 z-20 space-y-10 bg-white py-5" }
const _hoisted_21 = { class: "flex" }
const _hoisted_22 = { class: "text-xl" }
const _hoisted_23 = { class: "over flex-auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_full_text_search_component = _resolveComponent("full-text-search-component")!
  const _component_filter_summary_component = _resolveComponent("filter-summary-component")!
  const _component_search_controls_component = _resolveComponent("search-controls-component")!
  const _component_detail_filter_component = _resolveComponent("detail-filter-component")!
  const _component_object_teaser_component = _resolveComponent("object-teaser-component")!
  const _component_pagination_component = _resolveComponent("pagination-component")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("form", {
            onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _createVNode(_component_full_text_search_component, { class: "border-b relative mt-8 flex border-black" }),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("label", _hoisted_6, [
                _createTextVNode(_toDisplayString(_ctx.t('open_content')) + " ", 1),
                _createElementVNode("span", _hoisted_7, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    name: "open-content",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.basicFilter.openContent) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.basicFilter.openContent]
                  ]),
                  _cache[5] || (_cache[5] = _createElementVNode("svg", {
                    width: "27",
                    height: "27",
                    viewBox: "0 0 24 24",
                    focusable: "false",
                    "aria-hidden": "true"
                  }, [
                    _createElementVNode("circle", {
                      cx: "12",
                      cy: "12",
                      r: "11",
                      "stroke-width": "1",
                      stroke: "black",
                      class: "checkbox-mark",
                      "vector-effects": "non-scaling-stroke",
                      fill: "none"
                    })
                  ], -1))
                ])
              ]),
              _createElementVNode("button", {
                class: "button-filter md:hidden",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleFilter && _ctx.toggleFilter(...args))),
                "aria-pressed": _ctx.filterVisible ? 'true' : 'false'
              }, [
                _createTextVNode(_toDisplayString(_ctx.t('filter_toggle_label')) + " ", 1),
                (_ctx.numberOfSetFilters)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, "(" + _toDisplayString(_ctx.numberOfSetFilters) + ")", 1))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_8)
            ])
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _renderSlot(_ctx.$slots, "nav")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_filter_summary_component, { "total-count": _ctx.totalCount }, null, 8, ["total-count"])
    ], 512),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(_component_search_controls_component)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["row", _ctx.layoutClass])
    }, [
      (_ctx.filterVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            _createVNode(_component_detail_filter_component, {
              loading: _ctx.loadingFilters,
              class: "sticky top-103px max-h-screen overflow-y-auto"
            }, null, 8, ["loading"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["flex-1", { 'opacity-20': _ctx.loading }])
      }, [
        (_ctx.objects.length)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.objects, (object, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: object.id,
                  class: "object-teaser-wrapper"
                }, [
                  _createVNode(_component_object_teaser_component, {
                    object: object,
                    "persist-search": true,
                    index: index + _ctx.pagination.skip
                  }, null, 8, ["object", "index"])
                ]))
              }), 128))
            ]))
          : (_ctx.loading)
            ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_ctx.t('loading')), 1))
            : (_ctx.firstRequest)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("p", null, _toDisplayString(_ctx.t('no_results_message')), 1),
                  _renderSlot(_ctx.$slots, "noresult")
                ]))
              : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_17, [
          (_ctx.totalCount > _ctx.pagination.pageSize)
            ? (_openBlock(), _createBlock(_component_pagination_component, {
                key: 0,
                class: "mx-auto mt-20",
                pagination: _ctx.pagination,
                "total-count": _ctx.totalCount,
                onPrev: _ctx.prev,
                onNext: _ctx.next,
                onGoto: _ctx.goto
              }, null, 8, ["pagination", "total-count", "onPrev", "onNext", "onGoto"]))
            : _createCommentVNode("", true)
        ])
      ], 2)
    ], 2),
    _createVNode(_Transition, {
      "enter-active-class": "transition-opacity duration-100 ease-out",
      "leave-active-class": "transition-opacity duration-100 ease-in",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (_ctx.filterVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("header", _hoisted_21, [
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.t('filter_toggle_label')), 1),
                    _createElementVNode("button", {
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleFilter && _ctx.toggleFilter(...args))),
                      class: "ml-auto"
                    }, _cache[6] || (_cache[6] = [
                      _createElementVNode("span", { class: "sr-only" }, "Close", -1),
                      _createElementVNode("svg", {
                        width: "20",
                        height: "20",
                        focusable: "false",
                        "aria-hidden": "true"
                      }, [
                        _createElementVNode("use", { "xlink:href": "#close" })
                      ], -1)
                    ]))
                  ]),
                  _createVNode(_component_filter_summary_component, { "total-count": _ctx.totalCount }, null, 8, ["total-count"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_detail_filter_component, { loading: _ctx.loadingFilters }, null, 8, ["loading"])
                ]),
                (_ctx.numberOfSetFilters)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "fixed inset-x-0 bottom-0 z-10 w-full bg-black p-5 text-lg text-white",
                      onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleFilter && _ctx.toggleFilter(...args)))
                    }, _toDisplayString(_ctx.t('view_results')), 1))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ], undefined, true),
      _: 1
    })
  ]))
}